/* MC — Landing Reclinables
   1) Coloca el bloque de imagen/video + texto (rich video) justo arriba del
      bloque de Instagram, sin tocar la seccion.
   2) Los modelos sin precio cargado muestran "Proximamente" en vez de $0 y su
      boton de compra queda bloqueado. En cuanto el producto tenga precio en
      Shopify, todo vuelve solo al comportamiento normal. */
(function () {
  var SOON = 'Próximamente';

  function move() {
    var root = document.querySelector('.mc-page');
    if (!root) return;
    var rtv = root.querySelector('.mc-rtv');
    var ugc = root.querySelector('.mc-ugc');
    if (!rtv || !ugc || !ugc.parentNode) return;
    if (rtv.nextElementSibling === ugc) return;
    ugc.parentNode.insertBefore(rtv, ugc);
  }

  /* Un precio cuenta como "sin cargar" si todas sus cifras son cero. */
  function isZero(txt) {
    if (!txt) return false;
    var digits = txt.replace(/[^0-9]/g, '');
    return digits.length > 0 && /^0+$/.test(digits);
  }

  function current(el) {
    return el.dataset.mcSoon === '1' ? (el.dataset.mcPrev || '') : el.textContent;
  }

  function markSoon(el, size) {
    if (el.dataset.mcSoon !== '1') {
      el.dataset.mcPrev = el.textContent;
      el.dataset.mcSoon = '1';
      el.textContent = SOON;
    }
    el.style.fontSize = size;
    el.style.letterSpacing = '.01em';
  }

  function unmarkSoon(el) {
    if (el.dataset.mcSoon !== '1') return;
    delete el.dataset.mcSoon;
    delete el.dataset.mcPrev;
    el.style.fontSize = '';
    el.style.letterSpacing = '';
  }

  /* El boton conserva su texto; solo se bloquea. */
  function lockBuy(btn, lock) {
    if (lock) {
      if (btn.dataset.mcLock === '1') return;
      btn.dataset.mcLock = '1';
      if (btn.tagName === 'A') {
        btn.dataset.mcHref = btn.getAttribute('href') || '';
        btn.removeAttribute('href');
      } else {
        btn.disabled = true;
      }
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '.4';
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
    } else {
      if (btn.dataset.mcLock !== '1') return;
      delete btn.dataset.mcLock;
      if (btn.tagName === 'A' && btn.dataset.mcHref !== undefined) {
        btn.setAttribute('href', btn.dataset.mcHref);
        delete btn.dataset.mcHref;
      } else {
        btn.disabled = false;
      }
      btn.removeAttribute('aria-disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.style.cursor = '';
    }
  }

  function patchDetail(root) {
    var now = root.querySelector('.mc-price .now');
    if (!now) return;
    var soon = isZero(current(now));

    if (soon) markSoon(now, '24px'); else unmarkSoon(now);

    var was = root.querySelector('.mc-price .was');
    if (was) was.style.display = soon ? 'none' : '';

    var msi = root.querySelector('.mc-price .msi');
    if (msi) {
      if (soon) {
        if (!msi.dataset.mcPrev) msi.dataset.mcPrev = msi.textContent;
        msi.textContent = 'Disponible muy pronto.';
      } else if (msi.dataset.mcPrev) {
        msi.textContent = msi.dataset.mcPrev;
        delete msi.dataset.mcPrev;
      }
    }

    var atc = root.querySelector('.mc-atc');
    if (atc) lockBuy(atc, soon);
  }

  /* Tarjetas de la grilla: mismo criterio, sin tocar el enlace. */
  function patchCards(root) {
    root.querySelectorAll('.mc-pcard__price').forEach(function (box) {
      var now = box.querySelector('.now');
      if (!now) return;
      var soon = isZero(current(now));
      var was = box.querySelector('.was');
      var card = box.closest('.mc-pcard');
      var save = card && card.querySelector('.mc-pcard__save');
      if (soon) {
        markSoon(now, '15px');
        if (was) was.style.display = 'none';
        if (save) save.style.display = 'none';
      } else {
        unmarkSoon(now);
        if (was) was.style.display = '';
        if (save) save.style.display = '';
      }
    });
  }

  function run() {
    document.querySelectorAll('.mc-page').forEach(function (root) {
      patchDetail(root);
      patchCards(root);
    });
  }

  function watch() {
    document.querySelectorAll('.mc-page').forEach(function (root) {
      if (root.dataset.mcSoonWatch === '1') return;
      root.dataset.mcSoonWatch = '1';
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; run(); });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  function boot() { move(); run(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
